<div class="position-relative">
  <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

  <app-success-message [message]="successMessage"></app-success-message>
  <app-error-message [message]="errorMessage"></app-error-message>

  <form [formGroup]="paymentMethodsForm" (ngSubmit)="onSubmit()">
    <div formArrayName="methods" cdkDropList (cdkDropListDropped)="onDrop($event)">
      <div *ngFor="let method of methods.controls; let i = index" [formGroupName]="i"
           cdkDrag cdkDragLockAxis="y"
           class="d-flex justify-content-between align-items-center border-bottom py-2 bg-white">
        <span class="d-flex align-items-center gap-2">
          <mat-icon cdkDragHandle class="text-muted" style="cursor: grab;">drag_indicator</mat-icon>
          {{ method.get('name')?.value }}
        </span>
        <mat-slide-toggle formControlName="visible" color="primary">
          {{ method.get('visible')?.value ? 'Visible' : 'Hidden' }}
        </mat-slide-toggle>
      </div>
    </div>

    <p class="text-muted mt-3 mb-0" *ngIf="methods.controls.length === 0 && !showProgressSpinner">
      No payment methods found.
    </p>
    <p class="text-danger mt-3 mb-0" *ngIf="methods.controls.length > 0 && visibleCount === 0">
      At least one payment method must remain visible.
    </p>
  </form>

  <div class="d-flex justify-content-end mt-3" *ngIf="showSaveButton">
    <button mat-raised-button color="primary" type="button"
            [disabled]="showProgressSpinner || visibleCount === 0"
            (click)="onSubmit()">
      <mat-icon>save</mat-icon>
      Save Payment Methods
    </button>
  </div>
</div>
